const cleanupLocationHash = (hashToMatch: string) => {
  const currentHash = window.location.hash;
  if (currentHash === hashToMatch) {
    window.history.back();
  }
};

export default cleanupLocationHash;
